import { render, staticRenderFns } from "./CaseStatusTable.vue?vue&type=template&id=6274deec"
import script from "./CaseStatusTable.vue?vue&type=script&lang=js"
export * from "./CaseStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports